import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility'; // Import the visibility icon
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { saveData, getData, openDB } from '../../../utils/db';
import { fetchData, deleteData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import { Tooltip } from '@mui/material';

// import '../../App.css';

function RoomIndex() {
    const { isAuthenticated, companyId, permissions, isSuperAdmin, superCompanyId, logout, token } = useAuth();
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null); // Track the item ID to delete
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    let companyid = companyId;
    if (isSuperAdmin == true && companyId == superCompanyId) {
        companyid = 0;
    }


    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {
        fetchData('RoomApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    console.log(response);
                    setData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Company Details:', error);
            });
    }, []);

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const handleDelete = async () => {
        deleteData('RoomApi', `${deleteItemId}`, token)
            .then((response) => {
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
                window.location.reload();
            })


            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">

            <div className='w-full mb-2 flex flex-col md:flex-row items-center'>
                <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>
                    ROOMS
                </h6>

                <div className='flex items-center mt-2 md:mt-0 md:ml-4'>
                    <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                    {showSearchInput && (
                        <input
                            className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            style={{ marginLeft: '10px', width: '150px' }}
                        />
                    )}
                </div>

                <Tooltip title="Create New Room">
                    <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        style={{
                            marginTop: '10px',
                            marginLeft: '8px',
                            background: 'linear-gradient(to right, darkslategray, slategray)',
                            borderRadius: '50px',
                            padding: '10px 20px',
                            color: 'white',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '35px',
                        }}
                        component={Link}
                        to="/RoomCreate"
                    >
                        Create
                    </Button>
                </Tooltip>
            </div>


            <div className='w-full mb-5 flex' style={{ maxHeight: '500px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#0B5345' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#0B5345', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', color: 'white', textTransform: 'uppercase' }}>Sl.No</TableCell>
                                <TableCell sx={{ backgroundColor: '#0B5345', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', color: 'white', textTransform: 'uppercase' }}>Room Name /No.</TableCell>
                                <TableCell sx={{ backgroundColor: '#0B5345', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', color: 'white', textTransform: 'uppercase' }}>Description</TableCell>
                                <TableCell sx={{ backgroundColor: '#0B5345', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', color: 'white', textTransform: 'uppercase' }}>Rent Amount</TableCell>
                                <TableCell sx={{ backgroundColor: '#0B5345', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', color: 'white', textTransform: 'uppercase' }}>ACTIONS</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ backgroundColor: '#D5F5E3' }}>
                            {/* {data.map((index, item) => (
                                <TableRow key={item.ID}> */}
                            {data.map((item, index) => (
                                <TableRow key={item.Id}>
                                    <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '13px', padding: '1px', textAlign: 'left', fontWeight: 'bolder' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '13px', padding: '1px', textAlign: 'left', fontWeight: 'bolder' }}>{item.Name}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '13px', padding: '1px', textAlign: 'left', fontWeight: 'bolder' }}>{item.Description}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '13px', padding: '1px', textAlign: 'left', fontWeight: 'bolder' }}>{item.RentAmount}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '13px', padding: '1px', textAlign: 'left', fontWeight: 'bolder' }}>
                                        <Link to={`/RoomsEdit/${item.ID}`}>
                                            <IconButton>
                                                <EditIcon style={{ color: 'red' }} />
                                            </IconButton>
                                        </Link>

                                        <IconButton onClick={() => openConfirmDialog(item.ID)}>
                                            <DeleteIcon style={{ color: 'brown' }} />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>
                        </Dialog>
                    </Table>
                </TableContainer>
            </div>
        </div>

    );
}

export default RoomIndex;

